import React from "react";
import { Table } from "antd";
import "./Table.css";

const calculateColumnWidth = (text, padding = 16) => {
  return text?.length * 8 + padding;
};

const generateColumnsWithWidth = (columns, data) => {
  if (!Array.isArray(data)) {
    console.error("Data is not an array");
    return columns; // or return empty array, depending on requirements
  }

  return columns.map(({ widthText, widthPadding, widthMax, ...column }) => {

    const className = ["dynamic-table-cell", column.className].filter(Boolean).join(" ");

    if (column.width != null) {
      return { ...column, className };
    }

    const longestValue = data.reduce((max, row) => {
      const value = widthText
        ? widthText(row[column.dataIndex], row)
        : row[column.dataIndex];
      return value && value?.length > max?.length ? value : max;
    }, column.title || "");

    const width = Math.min(
      calculateColumnWidth(longestValue, widthPadding),
      widthMax ?? Infinity
    );
    return { ...column, width, className };
  });
};

const DynamicTable = ({ onChange, pagination, columns, data, onRowClick, onActionClick, expandable=null ,rowKey ="id", scroll = {}, tableLayout = "auto" }) => {
  const columnsWithWidth = generateColumnsWithWidth(columns, data);

  // Modify the onRowClick functionality
  const handleRowClick = (record) => {
    if (onRowClick) {
      onRowClick(record);
    }
  };

  // Add event handlers for actions
  const enhancedColumns = columnsWithWidth.map((col) => ({
    ...col,
    render: (text, record) => {
      if (col.dataIndex === "Actions" && onActionClick) {
        return (
          <div>
            {col.actions.map((action, idx) => (
              <button
                key={idx}
                className="btn btn-link"
                onClick={() => onActionClick(action.type, record)}
              >
                {action.label}
              </button>
            ))}
          </div>
        );
      }
      return col.render ? col.render(text, record) : text;
    },
  }));

  return (
    <Table
     scroll={{ y: "calc(100vh - 468px)", ...scroll }}
      columns={enhancedColumns}
      dataSource={data}
      pagination={pagination}
      onChange={onChange}
      rowKey={rowKey}
      expandable={expandable}
      tableLayout={tableLayout}
      className="dynamic-table"
      onRow={(record) => ({
        onClick: (e) => {
          if (e?.target?.closest('.ant-popover') || (e?.target?.closest('button'))) {
            return;
          }
          if (e?.target?.tagName === "TD" || e?.target?.tagName === "SPAN") {
            handleRowClick(record);
          }
        },
      })}
    />
  );
};

export default DynamicTable;
